import React from "react";
import { CreateTransactionData } from "@payment-client/interfaces/TxnApi";

export interface TransactionContextValue {
    createTransactionInProgress: boolean;
    processingTransaction: boolean;
    transactionData?: CreateTransactionData;
    doCreateTxn: (data: NonNullable<CreateTransactionData>) => void;
}

export const TransactionContext = React.createContext<TransactionContextValue>({
    createTransactionInProgress: false,
    doCreateTxn: () => void 0,
    processingTransaction: false,
});

if (__DEV__) {
    TransactionContext.displayName = "TransactionContext";
}
